import PropTypes from 'prop-types';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import NavItem from './NavItem';
import { useGetMenuMaster } from './../../../../api/menu';
import NavCollapse from './NavCollapse';

export default function NavGroup({ item }) {
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;

  const navCollapse = item.children?.map((menuItem) => {
    switch (menuItem.type) {
      case 'collapse':
        return <NavCollapse key={menuItem.id} item={menuItem} level={1} />;
      case 'item':
        return <NavItem key={menuItem.id} item={menuItem} level={1} />;
      default:
        return (
          <Typography key={menuItem.id} variant="h6" color="error" align="center">
            Fix - Group Collapse or Items
          </Typography>
        );
    }
  });

  const hasCollapse = item.children?.some((child) => child.type === 'collapse');

  return (
    <List
      disablePadding
      subheader={
        item.title && drawerOpen && !hasCollapse ? (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              px: 2.25,
              pt: 1.75,
              pb: 0.75
            }}
          >
            <Box
              sx={{
                width: 3,
                height: 13,
                borderRadius: '2px',
                bgcolor: 'var(--appMain300)',
                flexShrink: 0
              }}
            />
            <Typography
              sx={{
                fontSize: 10,
                fontWeight: 700,
                color: 'var(--appMain400)',
                letterSpacing: '0.1em',
                textTransform: 'uppercase',
                lineHeight: 1
              }}
            >
              {item.title}
            </Typography>
          </Box>
        ) : null
      }
      sx={{ mb: 0.25 }}
    >
      {navCollapse}
    </List>
  );
}

NavGroup.propTypes = { item: PropTypes.object };
